// 在悟空学习
import React, { useContext } from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import cls from 'classnames';

import { PC, Mobile } from '@wukong/haomao';
import { MyContext } from '../../../../config/context-manager';
import Title from '../Title';
import styles from './style.module.scss';

const StudyInWukong = () => {
  const { t } = useTranslation('mathSpecialty');
  const { locale } = useContext(MyContext);
  return (
    <section
      className={cls(styles.container, {
        [styles.localeEn]: locale === 'en',
      })}
    >
      <Mobile>
        <div>
          <div className={styles.mTitle}>
            <Title>{t('悟空学习-标题')}</Title>
          </div>
        </div>
      </Mobile>
      <div className={styles.contentContainer}>
        <PC>
          <div>
            <div className={styles.bg}>
              <Image src="/images/chinese-math-class/math/specialty/study-pc-bg.png" layout="fill" alt="在悟空学习" />
            </div>
          </div>
        </PC>
        <Mobile>
          <div>
            <div className={styles.bg}>
              <Image src="/images/chinese-math-class/math/specialty/study-bg-m.png" layout="fill" alt="在悟空学习" />
            </div>
          </div>
        </Mobile>
        <div className={styles.introduce}>
          <div className={styles.introduceBox}>
            <PC>
              <div>
                <Title>{t('悟空学习-标题')}</Title>
              </div>
            </PC>
            <p className={styles.content}>{t('悟空学习-内容')}</p>
            <div className={styles.introduceImg}>
              <Image
                src="https://cdnwukong.com/images/form/imgs/study-blackboard.gif"
                layout="responsive"
                width="500"
                height="500"
                alt="在悟空学习"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StudyInWukong;
